export function detectClient() {
    const fullUrl = window.location.href;
    const url = new URL(fullUrl)
    return url.host
}